import RpcClass from "../../../../../server/RpcClass.js";


import RpcNotFoundException from "../../../../../server/com/silkplm/engine/rpc/exceptions/RpcNotFoundException.js";

let locale;
if(typeof window !== "undefined") {
    locale = window?.navigator?.userLanguage || window?.navigator?.language || Intl.DateTimeFormat().resolvedOptions().locale;
} else {
    locale= RpcClass.locale = Intl.DateTimeFormat().resolvedOptions().locale;
}

const FULL_CLASS = 'com.silkplm.rpc.healthcheck.OrgEntityApi';

import LocalDate from "../../../../../server/LocalDate.js";
import LocalDateTime from "../../../../../server/LocalDateTime.js";
import LocalTime from "../../../../../server/LocalTime.js";



class OrgEntityApi extends RpcClass{

    /**
     *  @class OrgEntityApi
     *  @alias module:src/server/com/silkplm/rpc/healthcheck/OrgEntityApi.OrgEntityApi
     *  
     * */
    constructor(){
        super();


    }






    /** 
     * @async
     * @param parentEntityId {string} 
     * @param value {string} 
     * @throws {module:src/server/com/silkplm/engine/rpc/exceptions/RpcInternalException.RpcInternalException}
     * @returns {Promise<module:src/server/com/silkplm/model/healthcheck/OrgChildEntity.OrgChildEntity>}
     */
     addChildChecked(parentEntityId, value) {
            return RpcClass.rpcCall('/rpc/healthcheck/org-entity-api/add-child-checked', [parentEntityId, value]);
    }
    /** 
     * @async
     * @param parentEntityId {string} 
     * @param value {string} 
     * @throws {module:src/server/com/silkplm/engine/rpc/exceptions/RpcInternalException.RpcInternalException}
     * @returns {Promise<module:src/server/com/silkplm/model/healthcheck/OrgChildEntity.OrgChildEntity>}
     */
     addChildUnchecked(parentEntityId, value) {
            return RpcClass.rpcCall('/rpc/healthcheck/org-entity-api/add-child-unchecked', [parentEntityId, value]);
    }
    /** 
     * @async
     * @param value {string} 
     * @throws {module:src/server/com/silkplm/engine/rpc/exceptions/RpcInternalException.RpcInternalException}
     * @returns {Promise<module:src/server/com/silkplm/model/healthcheck/OrgEntity.OrgEntity>}
     */
     create(value) {
            return RpcClass.rpcCall('/rpc/healthcheck/org-entity-api/create', [value]);
    }
    /** 
     * @async
     * @param entity {module:src/server/com/silkplm/model/healthcheck/OrgEntity.OrgEntity} 
     * @throws {module:src/server/com/silkplm/engine/rpc/exceptions/RpcInternalException.RpcInternalException}
     * @returns {Promise<*>}
     */
     deleteUnchecked(entity) {
            return RpcClass.rpcCall('/rpc/healthcheck/org-entity-api/delete-unchecked', [entity]);
    }
    /** 
     * @async
     * @param entityId {string} 
     * @throws {module:src/server/com/silkplm/engine/rpc/exceptions/RpcInternalException.RpcInternalException}
     * @returns {Promise<number>}
     */
     doSomethingChecked(entityId) {
            return RpcClass.rpcCall('/rpc/healthcheck/org-entity-api/do-something-checked', [entityId]);
    }
    /** 
     * @async
     * @param child {module:src/server/com/silkplm/model/healthcheck/OrgChildEntity.OrgChildEntity} 
     * @throws {module:src/server/com/silkplm/engine/rpc/exceptions/RpcInternalException.RpcInternalException}
     * @returns {Promise<number>}
     */
     doSomethingWithChildChecked(child) {
            return RpcClass.rpcCall('/rpc/healthcheck/org-entity-api/do-something-with-child-checked', [child]);
    }
    /** 
     * @async
     * @param children {number[]} 
     * @throws {module:src/server/com/silkplm/engine/rpc/exceptions/RpcInternalException.RpcInternalException}
     * @returns {Promise<number>}
     */
     doSomethingWithListOfIds(children) {
            return RpcClass.rpcCall('/rpc/healthcheck/org-entity-api/do-something-with-list-of-ids', [children]);
    }
    /** 
     * @async
     * @param entity {module:src/server/com/silkplm/model/healthcheck/OrgEntity.OrgEntity} 
     * @throws {module:src/server/com/silkplm/engine/rpc/exceptions/RpcInternalException.RpcInternalException}
     * @returns {Promise<module:src/server/com/silkplm/model/healthcheck/OrgEntity.OrgEntity>}
     */
     editChecked(entity) {
            return RpcClass.rpcCall('/rpc/healthcheck/org-entity-api/edit-checked', [entity]);
    }
    /** 
     * @async
     * @param child {module:src/server/com/silkplm/model/healthcheck/OrgChildEntity.OrgChildEntity} 
     * @throws {module:src/server/com/silkplm/engine/rpc/exceptions/RpcInternalException.RpcInternalException}
     * @returns {Promise<module:src/server/com/silkplm/model/healthcheck/OrgChildEntity.OrgChildEntity>}
     */
     editChildChecked(child) {
            return RpcClass.rpcCall('/rpc/healthcheck/org-entity-api/edit-child-checked', [child]);
    }
    /** 
     * @async
     * @param child {module:src/server/com/silkplm/model/healthcheck/OrgChildEntity.OrgChildEntity} 
     * @throws {module:src/server/com/silkplm/engine/rpc/exceptions/RpcInternalException.RpcInternalException}
     * @returns {Promise<module:src/server/com/silkplm/model/healthcheck/OrgChildEntity.OrgChildEntity>}
     */
     editChildUnchecked(child) {
            return RpcClass.rpcCall('/rpc/healthcheck/org-entity-api/edit-child-unchecked', [child]);
    }
    /** 
     * @async
     * @param entity {module:src/server/com/silkplm/model/healthcheck/OrgEntity.OrgEntity} 
     * @throws {module:src/server/com/silkplm/engine/rpc/exceptions/RpcInternalException.RpcInternalException}
     * @returns {Promise<module:src/server/com/silkplm/model/healthcheck/OrgEntity.OrgEntity>}
     */
     editUnchecked(entity) {
            return RpcClass.rpcCall('/rpc/healthcheck/org-entity-api/edit-unchecked', [entity]);
    }
    /** 
     * @async
     * @param entityId {string} 
     * @throws {module:src/server/com/silkplm/engine/rpc/exceptions/RpcInternalException.RpcInternalException}
     * @returns {Promise<module:src/server/com/silkplm/model/healthcheck/OrgEntity.OrgEntity>}
     */
     getByIdChecked(entityId) {
            return RpcClass.rpcCall('/rpc/healthcheck/org-entity-api/get-by-id-checked', [entityId]);
    }
    /** 
     * @async
     * @param entityId {string} 
     * @throws {module:src/server/com/silkplm/engine/rpc/exceptions/RpcInternalException.RpcInternalException}
     * @returns {Promise<module:src/server/com/silkplm/model/healthcheck/OrgEntity.OrgEntity>}
     */
     getByIdUnchecked(entityId) {
            return RpcClass.rpcCall('/rpc/healthcheck/org-entity-api/get-by-id-unchecked', [entityId]);
    }
    /** 
     * @async
     * @param entityId {string} 
     * @throws {module:src/server/com/silkplm/engine/rpc/exceptions/RpcInternalException.RpcInternalException}
     * @returns {Promise<module:src/server/com/silkplm/model/healthcheck/OrgChildEntity.OrgChildEntity[]>}
     */
     getChildrenChecked(entityId) {
            return RpcClass.rpcCall('/rpc/healthcheck/org-entity-api/get-children-checked', [entityId]);
    }
    /** 
     * @async
     * @param entityId {string} 
     * @throws {module:src/server/com/silkplm/engine/rpc/exceptions/RpcInternalException.RpcInternalException}
     * @returns {Promise<module:src/server/com/silkplm/model/healthcheck/OrgChildEntity.OrgChildEntity[]>}
     */
     getChildrenUnchecked(entityId) {
            return RpcClass.rpcCall('/rpc/healthcheck/org-entity-api/get-children-unchecked', [entityId]);
    }
    /** 
     * @async
     * @param id {string} 
     * @throws {module:src/server/com/silkplm/engine/rpc/exceptions/RpcInternalException.RpcInternalException}
     * @returns {Promise<*>}
     */
     nullId(id) {
            return RpcClass.rpcCall('/rpc/healthcheck/org-entity-api/null-id', [id]);
    }
    /** 
     * @async
     * @param orgEntity {module:src/server/com/silkplm/model/healthcheck/OrgEntity.OrgEntity} 
     * @throws {module:src/server/com/silkplm/engine/rpc/exceptions/RpcInternalException.RpcInternalException}
     * @returns {Promise<*>}
     */
     nullOrgId(orgEntity) {
            return RpcClass.rpcCall('/rpc/healthcheck/org-entity-api/null-org-id', [orgEntity]);
    }


    /** @returns {string} */
    getRemoteClass(){
        return FULL_CLASS;
    }
}



let metadata = {};

metadata.__type__ = 'com.silkplm.rpc.healthcheck.OrgEntityApi';
metadata.__type_short__ = 'OrgEntityApi';
OrgEntityApi.prototype.__metadata__ = metadata;

OrgEntityApi.prototype.__cls__ = FULL_CLASS;

/** @module src/server/com/silkplm/rpc/healthcheck/OrgEntityApi */
export default OrgEntityApi

export { OrgEntityApi }
